import styles from "./Message.module.css";


export default function Message({ role, content }) {
    const alignmentClass = role === "assistant" ? styles.MMAIleftAlign : styles.MMAIrightAlign;

    return (
            <div className={`${alignmentClass} ${styles.MMAImessage}`}>
                <p>{content}</p>
            </div>
    );
}